/** @format */

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import PageLocator from "./Page-locaton/PageLocator";
import BoxResizer from "./Box-resizer";
import { Button, Dialog, DialogActions, DialogContent, Stack } from "@mui/material";
import FontSize from "./FontSize.js";
import FontFamily from "./FontFamily";
import { Icon } from "@iconify/react/dist/iconify.js";
import { updateSelectedDocument } from "../../../../store/reducers/pdfeditor/pdfDetailsSlice.js";
import { useDispatch, useSelector } from "react-redux";
import ToggleButton from "./ToggleButton/index.js";
import { updateAllCoordinates } from "../../../../store/reducers/pdfeditor/pdfCoordinatesSlice.js";
import { clearAllToolModificationData } from "../../../../store/reducers/pdfeditor/toolsModificationSlice.js";
import { getDocumentsDetailsApi } from "../../../../store/reducers/pdfeditor/getDocumentsDetailSlice.js";
import { pdfToolApi } from "../../../../services/PdfEditor/pdfToolApi.js";
import { updatePageData } from "../../../../store/reducers/pdfeditor/pageModificationSlice.js";
import { clearInsertPdf } from "../../../../store/reducers/pdfeditor/insertPdfSlice.js";
import { toast } from "react-toastify";
import { resetDeletedImages } from "../../../../store/reducers/pdfeditor/deletedImageSlice.js";
import { addSigner } from "../../../../store/reducers/pdfeditor/addSignerSlice.js";
// import AddText from "./AddText/index.js";

export const Tools = ({ containerRef, pdfPagesRef }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false)
  // const { selectedDocument } = useSelector((state) => state.uploadDocument);
  const {selectedDocument } = useSelector((state) => state.uploadDocument)
  const { coordinates } = useSelector((state) => state.pdfCoordinates || []);
  // console.log("selectedDocument", previousData)
  console.log('selectedDocument', selectedDocument)
  console.log('selectedDocument updatedCoordinates', coordinates)
  const [activeTool, setActiveTool] = useState({
    boxResizer: true,
    toggleButton: false
  });
  const countItemsInDocumentTemplate = (documentTemplate) => {
    let totalCount = 0;

    for (const pageKey in documentTemplate) {
        if (documentTemplate.hasOwnProperty(pageKey)) {
            const pageObject = documentTemplate[pageKey];

            for (const fieldKey in pageObject) {
                if (pageObject.hasOwnProperty(fieldKey)) {
                    const fieldArray = pageObject[fieldKey];

                    // Count the number of items in each field array
                    totalCount += Array.isArray(fieldArray) ? fieldArray.length : 0;
                }
            }
        }
    }

    return totalCount;
};
  const handleBackButton = () => {
    // let count = countItemsInDocumentTemplate(selectedDocument?.document_template)
    // console.log("count is ", count)
    // if(count!==coordinates.length) {
    //   setOpen(true)
    // }else{
    // }
    goBack()
  };
  const goBack = () => {
    dispatch(updateSelectedDocument(null));
    dispatch(updateAllCoordinates(null));
    dispatch(clearAllToolModificationData());
    dispatch(updatePageData([]));
    dispatch(clearInsertPdf({}));
    dispatch(resetDeletedImages([]))
    dispatch(addSigner(null));
    pdfToolApi.refreshToken().then((res) => {
      dispatch(getDocumentsDetailsApi(res?.access));
    });
  }

  return (
    <>
      <Stack direction='row' alignItems='center' spacing={2} sx={{ p: "3px 0"}}>
        <PageLocator containerRef={containerRef} pdfPagesRef={pdfPagesRef} />
        <BoxResizer activeTool={activeTool} setActiveTool={setActiveTool} />
        {/* <AddText /> */}
        {/* <FontSize /> */}
        {/* <FontFamily /> */}
        <ToggleButton activeTool={activeTool} setActiveTool={setActiveTool} />
      </Stack>
      <Dialog open = {open} close = {() => setOpen(false)}>
        <DialogContent>
          You have unsaved changes. Are you sure you want to leave?
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={()=>{goBack(); setOpen(false)}}>Yes</Button>
          <Button variant="contained" onClick={() => setOpen(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
      </>
  );
};